// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2pUlh","label":"SetPasswdForm_label__3vSUj"};